import React, { Dispatch, SetStateAction } from "react"
import {
  ActionButton,
  ActionButtonWrapper,
  Contacts,
  Container,
  Customer,
  Email,
  IconWrapper,
  Name,
  UserIcon
} from "./CustomerHeader.styled"
import { OrderAddress } from "lib/types/generated/graphql-types"
import CopyButton from "../../Ui/CopyButton"
import { WithAuth } from "../../Auth"
import { PermissionGroups } from "../../../routes/constants"
import { ReactComponent as DownIcon } from "images/icons/chevron-down.svg"
import { ReactComponent as OrderIcon } from "images/icons/cart-shopping.svg"
import { ReactComponent as AddressIcon } from "images/icons/address-card.svg"
import { ReactComponent as BanIcon } from "images/icons/ban.svg"
import { useNavigate } from "react-router-dom"
import { Tooltip } from "react-tooltip"

type Props = {
  address: OrderAddress
  handleEditAddressClick: () => void
  unsavedAddress: boolean
  editDisabled: boolean
  addressBlocked?: boolean
  showEdit: boolean
  expandableAddress?: boolean
  setExpanded?: Dispatch<SetStateAction<boolean>>
  expanded?: boolean
  showActionButtons?: boolean
}

const CustomerHeader = ({
  address,
  handleEditAddressClick,
  unsavedAddress,
  editDisabled,
  addressBlocked,
  showEdit,
  expandableAddress,
  setExpanded,
  expanded,
  showActionButtons
}: Props) => {
  const { givenName, familyName, email, telephoneNumber } = address

  const navigate = useNavigate()

  const handleCustomerClick = () => {
    navigate("/customer", { state: { email: address.email } })
  }

  return (
    <>
      <Container $editDisabled={editDisabled} $showEdit={showEdit}>
        <Customer>
          <UserIcon />
          <div>
            <Name>{`${givenName} ${familyName ? familyName : ""}`}</Name>
            <Contacts>
              <Email>
                {email} <CopyButton string={email} />
              </Email>
              <div>{telephoneNumber}</div>
            </Contacts>
          </div>
        </Customer>
          <ActionButtonWrapper>
            {addressBlocked ? (
              <WithAuth requiredGroups={PermissionGroups.orders.execute}>
                <Tooltip id="address-blocked-tooltip">
                  Blocked by a custom state
                </Tooltip>
                <span data-tooltip-id="address-blocked-tooltip">
                  <ActionButton disabled handleClick={handleEditAddressClick}>
                    <BanIcon />
                    Change address
                  </ActionButton>
                </span>
              </WithAuth>
            ) : (
              !editDisabled && (
                <WithAuth requiredGroups={PermissionGroups.orders.execute}>
                  <ActionButton handleClick={handleEditAddressClick}>
                    <AddressIcon />
                    {unsavedAddress ? "Confirm address change" : "Change address"}
                  </ActionButton>
                </WithAuth>
              )
            )}
            {showActionButtons && <ActionButton handleClick={handleCustomerClick}>
              <OrderIcon />
              See all orders
            </ActionButton>}
          </ActionButtonWrapper>
      </Container>
      {expandableAddress && !expanded && (
        <IconWrapper onClick={() => setExpanded && setExpanded(!expanded)}>
          <div>
            See Address
            <DownIcon />
          </div>
        </IconWrapper>
      )}
    </>
  )
}

export default CustomerHeader
